<div class="quantity-selector">
  <button type="button" (click)="decrement.emit()" aria-label="Decrease quantity">-</button>
  <span>{{ value }}</span>
  <button type="button" (click)="increment.emit()" aria-label="Increase quantity">+</button>
</div>
